import {
  TeamScheduleProvider,
  useTeamSchedule
} from "./TeamScheduleContext.js";
import TeamScheduleFilter from "./TeamScheduleFilter.js";
import TeamScheduleGrid from "./TeamScheduleGrid.js";

type TeamScheduleTaskDetailProps = (
  | { viewId: number }
  | {
      isPublicSchedule: boolean;
    }
  | {
      board_ids: number[];
    }
) & { slideoutContainerId?: string; timezone: string };

const TeamSchedule = (props: TeamScheduleTaskDetailProps) => {
  const args =
    "isPublicSchedule" in props
      ? { ...props, isPublic: props.isPublicSchedule }
      : props;
  return (
    <TeamScheduleProvider {...args}>
      <div className=" mx-auto max-w-(--breakpoint-lg) @container min-h-[calc(100%)] flex flex-col">
        <TeamScheduleFilter />
        <TeamScheduleGrid timeZone={props.timezone} />
      </div>
    </TeamScheduleProvider>
  );
};
export {
  TeamSchedule,
  TeamScheduleGrid,
  TeamScheduleFilter,
  TeamScheduleProvider,
  useTeamSchedule,
  type TeamScheduleTaskDetailProps
};
